module.exports = __webpack_public_path__ + "img/ceva-dark.464b9220.svg";